import { EXPIRATION_DATES, UserApiKey } from '@iot-platform/models/i4b';
import moment from 'moment';

export class UserApiKeyHelpers {
  static withIsExpired(userApiKey: UserApiKey): UserApiKey {
    return { ...userApiKey, isExpired: moment(userApiKey.expiresAt).isBefore(new Date()) };
  }

  static getExpirationPeriod(userApiKey: UserApiKey): { value: number; translationKey: string } {
    const diff = moment(userApiKey.expiresAt).diff(moment(userApiKey.issuedAt), 'days');
    return diff <= 15
      ? EXPIRATION_DATES.find((date) => date.value === 15)
      : diff > 15 && diff <= 180
        ? EXPIRATION_DATES.find((date) => date.value === 180)
        : EXPIRATION_DATES.find((date) => date.value === 365);
  }
}
